import { performFetch } from './utils'
import { browserHistory } from 'react-router'

export function loadICA(uuid) {
    return performFetch({
        type: 'LOAD_ICA',
        urlData: { uuid },
    })
}

export function submitICA(data) {
    return performFetch({
        type: 'SUBMIT_ICA',
        data,
        onSuccess: (data) => {
            browserHistory.push('/personal')
            return { type: 'SUBMIT_ICA_SUCCESS', data }
        },
        onSuccessActions: [
            { type: 'ONBOARDING_STEP_COMPLETE', step: 'ica' },
        ],
    })
}



// WEBPACK FOOTER //
// ./app/actions/ica.js